class CommonError extends Error {
  constructor ({ title, message, code = 'error', type = 'error' }) {
    super(message)
    this.title = title
    this.type = type
    this.code = code
  }
}

export default CommonError
